import i18n from "i18next";
import { initReactI18next } from "react-i18next";
i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        home: "Home",
        contacts: "Contacts",
        contactUs: "Contact-us",
        about: "About",
        fleet: "Fleet",
        address: "Address",
        phone: "Phone",
        informations: "Informations",
        information: "Information",
        termsAndConditions: "Terms & Conditions",
        privacyPolicy: "Privacy Policy",
        fullName: "Full Name",
        fullNameIsRequired: "Full name is required",
        fullNameInvalid: "Full name must have at least 3 characters",
        email: "Email",
        emailIsRequired: "Email is required",
        emailInvalid: "Email is not valid",
        phoneNumber: "Phone number",
        phoneNumberIsRequired: "Phone number is required",
        phoneNumberInvalid: "Phone number must have at least 9 characters",
        message: "Message",
        messageIsRequired: "Message is required",
        messageInvalid: "Message must have at least 3 characterss",
        submit: "Send",
        monday: "Monday",
        sunday: "Sunday",
        legal: "Legal",
        Portuguese: "Portuguese",
        Spanish: "Spanish",
        English: "English",
        German: "German",
        French: "French",
        emailSent: "Email sent successfully.",
        wipInfo:
          "Updates underway! Our reservation process is currently being improved for a better booking experience. Thank you for your patience.",
        deliveryDesk: "Pick-up Place",
        returnDesk: "Return Place",
        deliveryDate: "Pick-up Date",
        returnDate: "Return Date",
        deliveryTime: "Pick-up Time",
        returnTime: "Return Time",
        hotel: "Hotel",
        flight: "Flight",
        rentalPeriod: "Rental Period",
        myVehicle: "My Vehicle",
        optionals: "Optionals",
        clientData: "Client data",
        payment: "Payment",
        confirmation: "Confirmation",
        pickUp: "Pick-up",
        dropOff: "Return",
        group: "Group",
        orSimilar: "Or Similiar",
        carDetails: "Car Details",
        fuelType: "Fuel Type",
        gearbox: "Gearbox",
        seats: "Seats",
        doors: "Doors",
        from: "From",
        day: "Day",
        reserve: "Reserve",
        noCarsAvaiable: "No cars avaiable for the requested dates.",
        myCar: "My Car",
        myReservation: "My Reservation",
        carPerDayValue: "Daily rate",
        per: "per",
        days: "days",
        Days: "Days",
        extrasChoosed: "Extras choosed",
        noExtrasChoosed: "No extras choosed",
        extra: "Extra",
        cost: "Cost",
        totalPrice: "Total Price",
        partialPrice: "Partial value",
        continue: "Continue",
        clientDetails: "Client Details",
        birthDate: "Birth Date",
        city: "City",
        postalCode: "Postal Code",
        country: "Country",
        temporaryAddress: "Temporary Address",
        howItWorks: "How we work?",
        totalRentalPriceIs: "The total rental price is",
        bookingConfirmed: "Your Booking is Confirmed!",
        bookingSummary:
          "Thank you for choosing Why Not! Here's a summary of your purchase",
        orderId: "Order ID",
        adventure: "Get adventurous!",
        vehicleChoosed: "Vehicle Choosed",
        model: "Model",
        furtherQuestions: "For further questions, you can contact our team.",
        bestRegards: "Best Regards",
        search: "Search",
        about1:
          "M.I.Nunes, Unip., Lda., now under the commercial brand Why Not Car Rental, has more than forty years of experience in the market, and is represented in the center of Funchal, as well as 3 minutes from the airport. We have a diverse and very recent fleet of vehicles and scooters. If safety and comfort combined with quality and an affordable price are priorities for you, do not hesitate to contact a rental company recognized for its level of demand in terms of services and fleet.",
        about2:
          "At Why Not Car Rental, we believe that the freedom to explore shouldn't compromise your wallet. That's why we're committed to offering the best prices on the market. We work hard to ensure that our guests enjoy competitive rates, allowing them to make the most of their stay on the island of Madeira.",
        about3:
          "To make your experience even more enjoyable, Why Not Car Rental offers airport transportation. Nothing is more reassuring than knowing that, after your trip, one of our professionals will be ready to take you back to the airport, ensuring a smooth transition between your arrival and departure.",
        ourHistory: "Our Story",
        promiseFulfilled: "A Promise Fulfilled",
        moreConvenienceLessStress: "More Convenience, Less Stress",
        chooseYourWay: "Choose your way",
        hotelDeliveryInfo:
          "In this location is only possible to deliver and return cars in Hotels! (A fee of deliver and return will be applied 30 euros each way!)",
        airportDeliveryInfo:
          "When picking up your vehicle at the airport, you must wait outside the airport arrivals area. Our staff will be waiting for you with a sign with your name on it. Picking up/collecting your vehicle at this location has a one-off fee of 25 euros.",
        automatic: "Automatic",
        manual: "Manual",
        countryCode: "Country Code",
        outsideBusinessHours: "Outside of business hours (08:30 - 18:30)",
        northOutsideBusinessHours: "Outside of business hours (09:15 - 18:30)",
        pickUpDateValidation:
          "We're sorry, but vehicle rentals are only possible with a minimum notice period of 3 days from the current date. Please select a new date that fits within this range.",
        returnDateValidation: "Return date must be after Pick-up date",
        validDate: "The date is not valid",
        mandatory: "The field is mandatory",
        diesel: "Diesel",
        petrol: "Petrol",
        hybrid: "Hybrid",
        vehicleType: "Vehicle Type",
        small: "Small",
        medium: " Medium",
        large: " Grande",
        suv: " SUV",
        cabrio: " Cabriolet",
        miniVan: " Mini Van",
        van: " Van",
        eletric: "Electric",
        premium: "Premium",
        babySeat: "Baby Seat",
        babySeatIsofix: "Baby Seat Isofix",
        boosterSeat: "Booster Seat",
        fullInsurance: "Full Insurance",
        youngDriver: "Young Driver",
        additionalDriver: "Additional Driver",
        outOfHoursReturn: "Out of hours drop off",
        outOfHoursDeliverAfter23: "Out of hours deliver after 23h00",
        onlyString: "Only alphabets are allowed for this field",
        moreThan18YearsOld: "You need to be 21 years old or older",
        validCountryCode: "Insert a valid country code",
        iAmYoungDriver: "I am a young driver 21 to 25 years old",
        location: "Location",
        date: "Date",
        time: "Time",
        close: "Close",
        perDay: "Per day",
        perRent: "Per rental",
        fuelPolicy: "Full to Full Fuel Policy",
        fuelPolicyDescription:
          "The vehicle is delivered with a full tank and must be returned with the same amount of fuel. Missing fuel will be charged.",
        pickUpDropOffFlexibility: "Pick-up/Drop-off Flexibility",
        pickUpDropOffFlexibilityDescription:
          "Experience the flexibility of our pickup/delivery service. Have your car delivered in Funchal, or in the airport, the ship's port, the airport, and other locations on the island (subject to consultation)",
        unlimitedKilometers: "Unlimited Kilometers",
        unlimitedKilometersDescription:
          "Make the most of the island without any mileage restrictions.",
        tipsAndUpdates: "Personalized Tips",
        tipsAndUpdatesDescription:
          "Get personalized tips and updates to enhance your travel experience.",
        fullInsuranceDescription:
          "For a daily fee, feel completely safe in your vehicle, so you can make the most of your stay.",
        travelAssistance: "24/7 Travel Assistance",
        travelAssistanceDescription:
          "Our assistance team will be ready for any eventuality that may occur, providing an efficient and effective service.",
        deskInfoMessage:
          "All the deliveries and drop offs in this location need to be done in an hotel!",
        title: "explore Madeira island?",
        title2: "Book your car now!",
        requestQuote: "Request quote",
        quoteMessage: "I want a quote for the following group ",
        instructionsTitle: "Pick-up and drop-off instructions",
        airportInstructions:
          "Our vehicles are delivered at our office next to the airport located at Rua do cano 9, Santa Cruz. You can find the bus stop area, just outside the arrivals area. Our shuttle bus will be waiting for you there. You can contact us on +351291524023, or our WhatsApp +351967762981.",
        funchalInstructions:
          "Our vehicles are delivered at our office next to the municipal garden located at Rua Ivens nº12, Funchal. Any question our problem you can contact us on +351291213100, or our WhatsApp +351967762981.",
        hotelInstructions:
          "The vehicle will be delivered at your hotel/residence. We recommend that you wait at the reception or outside of the place that you are staying. Any question our problem you can contact us on +351291213100, or our WhatsApp +351967762981.",
        requestCarUnavaiable:
          "The requested car is not avaiable at the moment. Please choose another car, or contact us by email to check the avaiability of the requested car.",
        seeAll: "See All",
        youngDriverInfo:
          "A young drivers fee will be aplied in a value of 40 euros (21 - 25 years)",
        totalRentalValueInfo: "Total rental value including extras is",
        groupPreference: "Car Preference",
        reviews: "Recent Reviews",
        leaveAReview: "Write a review!",
        reservationDetails: "Rervation Details",
        changeDates: "Change Dates",
        aboutUsText:
          "Looking to rent a car in Madeira Island? Why Not Car Rental offers affordable, reliable car hire in Madeira airport, Funchal and across the island. With a diverse fleet and flexible rental options, we make exploring Madeira easy and convenient. Enjoy transparent pricing, easy pickup, and a stress-free booking experience. Discover Madeira at your own pace ! Book your car rental with us today!",
        reviewOf: "Review of ",
        timePickUpAfterReturn:
          "Pick-up time can´t be superior than the return time!",
        datesCanTBeEqual: "Dates can´t be equal!",
        datePlaceHolder: "Enter date in DD/MM/YYYY format",
        yes: "Yes",
        no: "No",
        fullInsuranceInfo:
          "This insurance covers all types of damages except: damage to the vehicle's interior, use of incorrect fuel, damage to the underside of the vehicle, and situations resulting from driver negligence. For any questions, please refer to the terms and conditions.",
        chooseInsurance: "Select an Insurance option",
        excessValue: "Excess in the value of ",
        excessInfo:
          "This deposit must be made by CREDIT CARD when the car is delivered. The stated deposit will be refunded to the client at the end of the rental period, provided no accident has occurred and no damage has been caused to the vehicle due to acts of vandalism, theft of the vehicle, or any of its accessories. This requirement can only be waived with the payment of Super C.D.W. (Comprehensive Insurance).",
        scooter: "Scooter",
        mandatoryExcess: "Non Waiverable responsibility in a value of 1000€",
        bigCar: "Large Car",
        filter: "Vehicles Filter",
        noFilteredCarsAvaiable:
          "Sorry, there are no cars available with the requested features.",
        withCanvasEletricRoof: "with Canvas Electric Roof",
        withPanoramicRoof: "with Panoramic Roof",
        readAndAccepted: "I have read and Accepted",
        choosePaymentMethod: "Choose the payment method",
        choosePaymentMode: "Choose the payment mode",
        pay20Now80Later: "Pay 20% now and 80% on the pick-up",
        proceedPayment: "Proceed to the payment",
        at: "at",
        partialValuePaid:
          "You only paid 20% of the rental, at the pick-up you need to pay the rest of the value!",
        payed: "You payed the value of ",
        totalValuePaid: "You paid the total value of the rental!",
        hello: "Hello",
        faq: "Frequently Asked Questions",
        outOfFunchalDelivery: "Out of Funchal Delivery fee",
        airportDeliveryExtra: "Airport Delivery fee",
        totalRentalValueIs: "The total rental value is",
        missingPayment:
          "Value that you need to pay on the pick-up of the vehicle.",
        howWeWork: "How we work?",
        featureTitle1: "Car Rental Across Madeira Island",
        featureDescription1:
          "At Why Not Car Rental, you can rent your vehicle anywhere on the beautiful Madeira Island!",
        featureTitle2: "Flexible Pick-up/Drop-off",
        featureDescription2:
          "Experience the flexibility of our pick-up/drop-off service. Have your car delivered in Funchal (no extra cost), at the airport, or other locations on the island (subject to inquiry).",
        featureTitle3: "Unlimited Mileage",
        featureDescription3:
          "Make the most of the island without any mileage restrictions.",
        featureTitle4: "Personalized Tips",
        featureDescription4:
          "Our team will ensure to provide you with all the tips that best suit your needs.",
        featureTitle5: "Full Insurance",
        featureDescription5:
          "With a daily fee, feel completely secure in your vehicle, allowing you to make the most of your stay.",
        featureTitle6: "24/7 Travel Assistance",
        featureDescription6:
          "Our assistance team will be ready for any eventuality that may arise, providing efficient and effective service.",
        filters: "Filters",
        clearFilters: "Clear Filters",
        viewDeal: "View Deal",
        additionalDriverPromotion: "Additional driver free of charge",
        specialOffer: "Special Offer",
        FREE: "FREE",
        allBookings: "in all bookings",
      },
    },
    pt: {
      translation: {
        home: "Home",
        contacts: "Contactos",
        contactUs: "Contacte-nos",
        about: "Sobre nós",
        fleet: "Frota",
        address: "Morada",
        phone: "Telefone",
        informations: "Informações",
        termsAndConditions: "Termos e Condições",
        privacyPolicy: "Politica de Privacidade",
        fullName: "Nome Completo",
        fullNameIsRequired: "Nome é obrigatório",
        fullNameInvalid: "O nome deve ter pelo menos 3 caracteres",
        email: "Email",
        emailIsRequired: "Email é obrigatório",
        emailInvalid: "O Email não é valido",
        phoneNumber: "Número de telefone",
        phoneNumberIsRequired: "Número de telefone é obrigatório",
        phoneNumberInvalid:
          "O número de telefone deve ter pelo menos 9 caracteres",
        message: "Mensagem",
        messageIsRequired: "Mensagem é obrigatório",
        messageInvalid: "A mensagem deve ter pelo menos 3 caracteres",
        submit: "Enviar",
        monday: "Segunda-Feira",
        sunday: "Domingo",
        legal: "Legal",
        Portuguese: "Português",
        Spanish: "Espanhol",
        English: "Inglês",
        German: "Alemão",
        French: "Francês",
        emailSent: "Email enviado com sucesso.",
        wipInfo:
          "Atualizações em andamento! Nosso processo de reservas está a ser melhorado para uma melhor experiência de reserva. Obrigado pela sua paciência.",
        deliveryDesk: "Local de Levantamento",
        returnDesk: "Local de Devolução",
        deliveryDate: "Data de Levantamento",
        returnDate: "Data de Devolução",
        deliveryTime: "Hora de Levantamento",
        returnTime: "Hora de Devolução",
        hotel: "Hotel",
        flight: "Nº de Voo",
        rentalPeriod: "Período de Aluguer",
        myVehicle: "A minha viatura",
        optionals: "Opcionais",
        clientData: "Dados Cliente",
        payment: "Pagamento",
        confirmation: "Confirmação",
        pickUp: "Levantamento",
        dropOff: "Devolução",
        group: "Grupo",
        orSimilar: "Ou Similar",
        carDetails: "Detalhes da viatura",
        fuelType: "Combustível",
        gearbox: "Transmissão",
        seats: "Lugares",
        doors: "Portas",
        from: "Desde",
        day: "Dia",
        reserve: "Reservar",
        noCarsAvaiable: "Não há carros disponíveis para as datas selecionadas.",
        myCar: "A minha Viatura",
        myReservation: "A minha Reserva",
        carPerDayValue: "Tarifa diária",
        per: "por",
        days: "dias",
        Days: "Dias",
        extrasChoosed: "Extras escolhidos",
        noExtrasChoosed: "Nenhum extra escolhido",
        extra: "Extra",
        cost: "Custo",
        totalPrice: "Preço Total",
        partialPrice: "Valor Parcial",
        continue: "Continuar",
        clientDetails: "Dados Cliente",
        birthDate: "Data de Nascimento",
        city: "Cidade",
        postalCode: "Codigo Postal",
        country: "País",
        temporaryAddress: "Endereço Temporário",
        totalRentalPriceIs: "O preço total do aluguer é",
        bookingConfirmed: "A sua reserva foi confirmada!",
        bookingSummary:
          "Obrigado por escolher a Why Not! Seguem abaixo os detalhes da sua reserva:",
        orderId: "ID da reserva",
        vehicleChoosed: "Viatura Escolhida",
        model: "Modelo",
        furtherQuestions:
          "Em caso de alguma dúvida, não hesite em contactar a nossa equipa.",
        bestRegards: "Com os melhores cumprimentos",
        search: "Pesquisar",
        howItWorks: "Como funcionamos?",
        about1:
          "A M.I.Nunes, Unip., Lda. agora com a marca comercial Why Not Car Rental, conta com mais de quarenta anos de experiência no mercado, e, está representada no centro do Funchal, bem como a 3 minutos do aeroporto. Dispomos de uma frota de viaturas e scooters diversificada e muito recente. Se a segurança e o conforto aliados à qualidade e a um preço acessível são prioridades para si, não hesite em contactar uma companhia de aluguer reconhecida pelo seu grau de exigência quer a nível dos serviços, quer da frota.",
        about2:
          "Na Why Not Car Rental, acreditamos que a liberdade de explorar não deve comprometer o seu bolso. É por isso que nos comprometemos a oferecer os melhores preços do mercado. Trabalhamos arduamente para garantir que os nossos clientes desfrutem de tarifas competitivas, permitindo-lhes tirar o máximo proveito da sua estadia na ilha da Madeira.",
        about3:
          "Para tornar a sua experiência ainda mais agradável, a Why Not Car Rental oferece transporte para o aeroporto. Nada é mais reconfortante do que saber que, após a sua viagem, um dos nossos profissionais estará pronto para o levar de volta ao aeroporto, garantindo uma transição suave entre a sua chegada e partida.",
        ourHistory: "A nossa história",
        promiseFulfilled: "Uma promessa cumprida",
        moreConvenienceLessStress: "Mais conveniência, menos stress",
        chooseYourWay: "Escolha a sua medida",
        hotelDeliveryInfo:
          "Nesta localização é apenas possível levantar e devolver as viaturas em hoteis! Uma taxa de levantamento e de devolução será aplicada. (30 euros cada)",
        airportDeliveryInfo:
          "Ao levantar a viatura no aeroporto, devera de aguardar no exterior das chegadas do aeroporto. O nosso colaborador estará a espera de si com uma placa com o seu nome. O levantamento/recolha da viatura neste local tem uma taxa única de 25 euros.",
        adventure: "Aventura-te!",
        automatic: "Automático",
        manual: "Manual",
        countryCode: "Indicativo",
        outsideBusinessHours: "Fora de horas de serviço (08:30 - 18:30)",
        northOutsideBusinessHours: "Fora de horas de serviço (09:15 - 18:30)",
        pickUpDateValidation:
          "Lamentamos, mas o aluguer de veículos só é possível com uma antecedência mínima de 3 dias a partir da data atual. Por favor, selecione uma nova data que respeite este intervalo.",
        returnDateValidation:
          "Data de devolução tem que ser superior a data de levantamento!",
        fuelPolicy: "Política de Combustível Cheio a Cheio",
        fuelPolicyDescription:
          "O veículo é entregue com o tanque cheio e deve ser devolvido com a mesma quantidade de combustível. O combustível em falta será cobrado.",
        pickUpDropOffFlexibility: "Flexibilidade de Levantamento/ Recolha",
        pickUpDropOffFlexibilityDescription:
          "Experimente a flexibilidade do nosso serviço de recolha/entrega. Pode receber o seu carro em qualquer lugar da Ilha da Madeira, no nosso escritório do Funchal ou no aeroporto, e em outros locais da ilha, como hotéis. (sujeito a consulta)",
        unlimitedKilometers: "Quilómetros Ilimitados",
        unlimitedKilometersDescription:
          "Aproveite ao máximo a ilha sem restrições de quilometragem.",
        tipsAndUpdates: "Dicas Personalizadas",
        tipsAndUpdatesDescription:
          "Receba dicas e atualizações personalizadas para melhorar sua experiência de viagem.",
        fullInsuranceDescription:
          "Por uma taxa diária, sinta-se completamente seguro em seu veículo para aproveitar ao máximo sua estadia.",
        travelAssistance: "24/7 Assistência de Viagem",
        travelAssistanceDescription:
          "A Nossa equipa de assistência estará preparada para qualquer eventualidade que possa ocorrer, prestando um serviço rápido e eficaz.",
        validDate: "A data não é válida",
        mandatory: "O campo é obrigatório",
        diesel: "Gasóleo",
        petrol: "Gasolina",
        hybrid: "Híbrido",
        vehicleType: "Tipo de viatura",
        small: "Pequeno",
        medium: "Médio",
        large: "Grande",
        suv: "SUV",
        cabrio: "Cabriolet",
        miniVan: "Monovolume",
        van: "Carrinha",
        eletricCar: "Elétrico",
        premium: "Premium",
        babySeat: "Cadeira de bebê",
        babySeatIsofix: "Cadeira de bebê com isofix",
        boosterSeat: "Banco elevatório",
        fullInsurance: "Seguro Completo",
        youngDriver: "Condutor Jovem",
        additionalDriver: "Condutor Adicional",
        outOfHoursReturn: "Devolução fora de horas",
        outOfHoursDeliverAfter23: "Devolução fora de horas após as 23h00",
        onlyString: "Apenas letras são permitidas",
        moreThan21YearsOld: "Têm que ter pelo menos 21 anos de idade",
        validCountryCode: "Introduza um código válido",
        iAmYoungDriver: "Sou um jovem condutor de 21 a 25 anos",
        location: "Localização",
        instructionsTitle: "Intruções de levantamento e devolução",
        airportInstructions:
          "Os veículos são entregues no nosso escritório perto do aeroporto, localizado na Rua do Cano nº 9, Santa Cruz. Você encontrará o nosso transporte, uma carrinha de 9 lugares, logo na saída das chegadas do aeroporto, um funcionario estara a aguardar por si no exterior. Em caso de dúvida entre em contacto através do número +351291213100 ou do nosso WhatsApp +351967762981.",
        funchalInstructions:
          "As nossas viaturas são entregues no nosso escritório junto ao jardim municipal, localizado no centro do Funchal na Rua Ivens nº12. Para qualquer dúvida ou problema, entre em contacto connosco através do número +351291213100 ou do nosso WhatsApp +351967762981.",
        hotelInstructions:
          "A viatura será entregue no hotel/alojamento pretendido. Recomendamos que aguarde na receção ou no exterior da mesma. Em caso de alguma dúvida entre em contacto connosco, através do número +351291213100 ou do nosso WhatsApp +351967762981.",
        date: "Data",
        time: "Hora",
        close: "Fechar",
        perDay: "Por dia",
        perRent: "Por aluguer",
        deskInfoMessage:
          "Todas os levantamentos e devoluções nesta localização têm que ser realizadas num hotel!",
        title: "explorar a ilha da Madeira?",
        title2: "Reserve o seu carro agora!",
        moreThan18YearsOld: "A idade tem que ser igual ou superior a 21 anos!",
        requestQuote: "Pedir cotação",
        quoteMessage: "Queria uma cotação para o seguinte grupo ",
        information: "Informação",
        requestCarUnavaiable:
          "A viatura escolhida de momento não se encontra disponível. Por favor escolha outra viatura, ou então pode nos contactar por email para verificar a disponibilidade da mesma.",
        seeAll: "Ver todos",
        youngDriverInfo:
          "Uma taxa de condutor jovem será aplicada no valor de 40 euros (21 - 25 anos)",
        groupPreference: "Grupo escolhido",
        reviews: "Avaliações Recentes",
        leaveAReview: "Faça uma avaliação!",
        reservationDetails: "Detalhes da reserva",
        changeDates: "Alterar datas",
        aboutUsText:
          "Quer alugar um carro na Ilha da Madeira? A Why Not Car Rental oferece preços acessíveis, carros fiáveis e levantamentos no aeroporto da Madeira, Funchal e em toda a ilha. Com uma frota diversificada e opções de aluguer flexíveis, tornamos a exploração da Madeira fácil e conveniente. Desfrute de preços transparentes, devolução fácil e sem stress. Descubra a Madeira ao seu ritmo! Reserve hoje mesmo o seu aluguer de carro connosco!",
        reviewOf: "Crítica de ",
        totalRentalValueInfo: "O valor total do aluguer incluindo extras é",
        timePickUpAfterReturn:
          "A hora de levantamento nao pode ser superior a hora de recolha!",
        datesCanTBeEqual: "As datas não podem ser iguais!",
        datePlaceHolder: "Introduza a data no formato DD/MM/YYYY",
        yes: "Sim",
        no: "Não",
        fullInsuranceInfo:
          "Este seguro cobre todos os tipos de danos, exceto: danos no interior da viatura, uso de combustível inadequado, danos na parte inferior do veículo e situações decorrentes de negligência do condutor. Em caso de dúvidas, consulte os termos e condições para mais informações.",
        chooseInsurance: "Selecione uma opção de Seguro",
        excessValue: "Franquia no valor de ",
        excessInfo:
          "Esta fránquia deve ser feita no levantamento do carro por CARTÃO DE CRÉDITO. A fránquia referida será reembolsada ao cliente no fim do aluguer, caso nenhum acidente tenha ocorrido , nem como nenhum dano causado ao veículo por atos de Vandalismo, roubo do veículo ou de qualquer um de seus acessórios. Esta situação só pode ser eliminada com o pagamento de Super C.D.W. (Seguro todos os riscos)",
        scooter: "Scooter",
        mandatoryExcess: "Franquia obrigatória no valor de 1000€",
        bigCar: "Carro Grande",
        filter: "Filtro de veículos",
        noFilteredCarsAvaiable:
          "Desculpe, não há carros disponíveis com as características solicitadas.",
        withCanvasEletricRoof: "com Teto de lona elétrico",
        withPanoramicRoof: "com teto Panorâmico",
        readAndAccepted: "Li e Aceito",
        choosePaymentMethod: "Selecione o método de pagamento",
        choosePaymentMode: "Selecione a modalidade de pagamento",
        pay20Now80Later: "Pague 20% agora e 80% no levantamento",
        proceedPayment: "Proceder para o pagamento",
        at: "às",
        partialValuePaid:
          "Apenas pagou 20% do aluguer. No levantamento da viatura terá que pagar os restantes 80%!",
        totalValuePaid: "Pagou a totalidade do aluguer!",
        payed: "Pagou o valor de ",
        hello: "Olá",
        faq: "Perguntas frequentes",
        outOfFunchalDelivery: "Taxa de entrega/recolha fora do Funchal",
        airportDeliveryExtra: "Taxa de entrega/recolha no aeroporto",
        totalRentalValue: "Valor total do aluguer",
        totalRentalValueIs: "O valor total do aluguer é",
        missingPayment: "Valor que terá de pagar no levantamento da viatura.",
        howWeWork: "Como funcionamos?",
        featureTitle1: "Aluguer em toda a Ilha da Madeira",
        featureDescription1:
          "Na why not car rental é possível aluguar a sua viatura em qualquer parte da Ilha da Madeira!",
        featureTitle2: "Flexibilidade de Levantamento/ Recolha",
        featureDescription2:
          "Experimente a flexibilidade do nosso serviço de recolha/entrega. Tenha o seu carro entregue no Funchal (sem custos), no aeroporto e noutros locais da ilha (sujeito a consulta).",
        featureTitle3: "Quilómetros ilimitados",
        featureDescription3:
          "Tire o maior proveito da ilha sem quaisquer restrições de quilometragem.",
        featureTitle4: "Dicas Personalizadas",
        featureDescription4:
          "A nossa equipa irá certificar-se de transmitir todas as dicas que melhor se adequam às suas necessidades.",
        featureTitle5: "Seguro Completo",
        featureDescription5:
          "Através de uma taxa diária sinta-se totalmente seguro na sua viatura, de forma a aproveitar da melhor forma a sua estadia.",
        featureTitle6: "Assistência de Viagem 24/7",
        featureDescription6:
          "A nossa equipa de assistência encontrar-se-á pronta para qualquer eventualidade que possa acontecer, prestando um serviço eficiente e eficaz.",
        filters: "Filtros",
        clearFilters: "Limpar Filtros",
        viewDeal: "Ver Oferta",
        additionalDriverPromotion: "Condutor adicional gratuito",
        specialOffer: "Oferta Especial",
        FREE: "GRÁTIS",
        allBookings: "em todas as reservas",
      },
    },
    // es: {
    //   translation: {
    //     home: "Casa",
    //     contacts: "Contactos",
    //     about: "Acerca de",
    //     fleet: "Flota",
    //     address: "Dirección",
    //     phone: "Teléfono",
    //     informations:"Informaciones",
    //     termsAndConditions: "Términos y Condiciones",
    //     privacyPolicy: "Política de privacidad",
    //     fullName:"Nombre completo",
    //     fullNameIsRequired:"El nombre es obligatorio",
    //     fullNameInvalid:"El nombre debe tener al menos 3 caracteres.",
    //     email:"Email",
    //     emailIsRequired:"El correo electrónico es obligatorio",
    //     emailInvalid:"El correo electrónico no es válido.",
    //     phoneNumber:"Número de teléfono",
    //     phoneNumberIsRequired:"Se requiere número de teléfono",
    //     phoneNumberInvalid:"El número de teléfono debe tener al menos 9 caracteres.",
    //     message:"Mensaje",
    //     messageIsRequired:"El mensaje es obligatorio",
    //     messageInvalid:"El mensaje debe tener al menos 3 caracteres.",
    //     submit:"Mandar",
    //     monday:"Lunes",
    //     sunday:"Domingo",
    //     legal:"Fresco",
    //     Portuguese: "portugués",
    //     Spanish: "Español",
    //     English: "Inglés",
    //     German: "Alemán",
    //     French: "Francés",
    //     emailSent:"Email enviado correctamente."
    //   },
    // },
    // de: {
    //   translation: {
    //     home: "Home",
    //     contacts: "Contactos",
    //     about: "Sobre-nós",
    //     fleet: "Frota",
    //     address: "Morada",
    //     phone: "Telefone",
    //     informations:"Informações",
    //     termsAndConditions: "Termos e Condições",
    //     privacyPolicy: "Politica de Privacidade",
    //     fullName:"Nome Completo",
    //     fullNameIsRequired:"Nome é obrigatório",
    //     fullNameInvalid:"O nome deve ter pelo menos 3 caracteres",
    //     email:"Email",
    //     emailIsRequired:"email é obrigatório",
    //     emailInvalid:"O email não é valido",
    //     phoneNumber:"Número de telefone",
    //     phoneNumberIsRequired:"número de telefone é obrigatório",
    //     phoneNumberInvalid:"O número de telefone deve ter pelo menos 9 caracteres",
    //     message:"Mensagem",
    //     messageIsRequired:"Mensagem é obrigatório",
    //     messageInvalid:"A mensagem deve ter pelo menos 3 caracteres",
    //     submit:"Enviar",
    //     monday:"Segunda-Feira",
    //     sunday:"Domingo",
    //     legal:"Legal",
    //     Portuguese: "Portugues",
    //     Spanish: "Espanhol",
    //     English: "Inglês",
    //     German: "Alemão",
    //     French: "Francês",
    //   },
    // },
    // fr: {
    //   translation: {
    //     home: "Home",
    //     contacts: "Contactos",
    //     about: "Sobre-nós",
    //     fleet: "Frota",
    //     address: "Morada",
    //     phone: "Telefone",
    //     informations:"Informações",
    //     termsAndConditions: "Termos e Condições",
    //     privacyPolicy: "Politica de Privacidade",
    //     fullName:"Nome Completo",
    //     fullNameIsRequired:"Nome é obrigatório",
    //     fullNameInvalid:"O nome deve ter pelo menos 3 caracteres",
    //     email:"Email",
    //     emailIsRequired:"email é obrigatório",
    //     emailInvalid:"O email não é valido",
    //     phoneNumber:"Número de telefone",
    //     phoneNumberIsRequired:"número de telefone é obrigatório",
    //     phoneNumberInvalid:"O número de telefone deve ter pelo menos 9 caracteres",
    //     message:"Mensagem",
    //     messageIsRequired:"Mensagem é obrigatório",
    //     messageInvalid:"A mensagem deve ter pelo menos 3 caracteres",
    //     submit:"Enviar",
    //     monday:"Segunda-Feira",
    //     sunday:"Domingo",
    //     legal:"Legal",
    //     Portuguese: "Portugues",
    //     Spanish: "Espanhol",
    //     English: "Inglês",
    //     German: "Alemão",
    //     French: "Francês",
    //   },
    // },
  },
});

export default i18n;
